import UserRolesService from "../../services/usersRoles";

const getDefaultState = () => {
    return {

    }
}
const state = getDefaultState()

const getters = {
   
};

const actions = {
    GetProtegoUserRoleReport(st, data) {
        return UserRolesService.GetProtegoUserRoleReport(
            data,
            st.rootState.auth.idToken
        );
    },
    GetAllRoles(st) {
        return UserRolesService.GetAllRoles(
            st.rootState.auth.idToken
        );
    },
    GetAllAgencies(st) {
        return UserRolesService.GetAllAgencies(
            st.rootState.auth.idToken
        );
    },
    GetAllPermissions(st) {
        return UserRolesService.GetAllPermissions(
            st.rootState.auth.idToken
        );
    },
    DownloadList(st, data) {
        return UserRolesService.DownloadList(st.rootState.auth.idToken, data);
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};